<template>
 <b-card class="mb-2" >
    <b-row >
        <b-col>
            <h4 class="card-title mb-0">Rapporterad tid och beläggningsgrad</h4>
        </b-col>
        <b-col>
            <DateCarousel class="float-right d-none d-md-block" :date=date @onDateChanged="onMonthChanged"/>
        </b-col>
    </b-row>
    <b-row>
        <b-col class="col-12 col-sm-12 col-md-6 col-lg-6" >
            <ProjectTaskUtilizationChart v-if="projectTaskUtilization" :projectTaskUtilization=projectTaskUtilization class="mt-4" :key="componentIndex"/>
        </b-col>
        <b-col class="col-12 col-sm-12 col-md-6 col-lg-6">
            <OccupancyChart v-if="projectTaskUtilization" :userUtilization=userUtilization :companyUtilization=companyUtilization :key="componentIndex"  />
        </b-col>
    </b-row>
 </b-card>
</template>

<script>
import { statisticsService } from "../../shared/services";
import OccupancyChart from './charts/OccupancyChart'
import ProjectTaskUtilizationChart from './charts/ProjectTaskUtilizationChart'
import DateCarousel from '../components/DateCarousel'
export default {
    components: {
        DateCarousel,
        OccupancyChart,
        ProjectTaskUtilizationChart
    },
    computed: {
        dateLabel() {
            return `${this.monthNames[this.date.month()]} ${this.date.year()}`
        },
        userUtilization() {
            var sum = this.projectTaskUtilization.userUtilization.utilization.filter(u => u.isBillable).reduce((sum, item) => sum + item.hours, 0);
            var utilization = (sum/this.projectTaskUtilization.userUtilization.totalWorkingHours*100).toFixed(0);
            return parseInt(utilization);
        },
        companyUtilization() {
            if(!this.projectTaskUtilization.companyUtilization) return null;
            var sum = this.projectTaskUtilization.companyUtilization.utilization.filter(u => u.isBillable).reduce((sum, item) => sum + item.hours, 0);
            var utilization = (sum/this.projectTaskUtilization.companyUtilization.totalWorkingHours*100).toFixed(0);
            return parseInt(utilization);
        }
    },
    data: function () {
        return {
            componentIndex: 0,
            monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
            date : this.$moment().add(-1, 'M'),
            projectTaskUtilization : null,
        }
    },

    async mounted() {
        this.projectTaskUtilization =  await this.LoadUtilization();
    },

    methods: {
        async onMonthChanged(date) {
            this.date = date;
            this.projectTaskUtilization = await this.LoadUtilization();
            this.componentIndex++;
        },
        async LoadUtilization() {
            try {
                var userProjectTaskUtilizationCall = statisticsService.getProjectTaskUtilization(this.loginState.user.id, this.date.year(), this.date.month() + 1);
                var companyProjectTaskUtilizationCall = statisticsService.getProjectTaskUtilization(this.date.year(), this.date.month() + 1);
                let promises = [userProjectTaskUtilizationCall];
                if(this.loginState.isAdministrator) promises.push(companyProjectTaskUtilizationCall);
                const [userProjectTaskUtilizationResult, companyProjectTaskUtilizationResult] = await Promise.all(promises);

                return {userUtilization : userProjectTaskUtilizationResult, companyUtilization : companyProjectTaskUtilizationResult }
            } catch(e) {
                this.ShowToast(
                "Fel",
                "Ett okänt fel uppstod när statistik skulle läsas",
                "danger"
                );
            }
        },
    },
}
</script>



<style>

</style>